import Image from 'next/image'
import styles from './CTA.module.scss'

export interface ctaSubtext {
  icon: any
  text: string
}

const CTASubtext = ({ icon, text }: ctaSubtext) => {
  const { name, alternativeText, height, width, url } = icon?.data?.attributes
  return (
    <div className={styles.ctaSubtext}>
      <div className={styles.iconWrapper}>
        <Image src={url} width={width} height={height} alt={alternativeText || name} />
      </div>
      <p className={styles.subtextLabel}>{text}</p>
    </div>
  )
}

export default CTASubtext
